import { useEffect, useRef } from 'react';

interface BattleLogProps {
  messages: string[];
}

const BattleLog: React.FC<BattleLogProps> = ({ messages = [] }) => {
  const logRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="bg-[#1A2634] rounded-lg p-4">
      <h3 className="text-lg font-semibold mb-2">Battle Log</h3>
      <div 
        ref={logRef}
        className="h-[200px] md:h-[300px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-800"
      >
        <div className="space-y-2">
          {messages.map((message, index) => (
            <p 
              key={index} 
              className="text-sm text-gray-300 leading-relaxed border-l-2 border-gray-700 pl-3"
            >
              {message}
            </p>
          ))}
          {messages.length === 0 && (
            <p className="text-sm text-gray-500 italic">
              The battle will begin soon...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BattleLog; 